import {FormControl, FormHelperText, FormLabel} from "@mui/material";
import React from "react"
import {CommonProps} from "./types/types";
import {StatusUpdateAnswer} from "../types/UpdatePartyObject";
import {withSharedMemo} from "./memo/memoComponent";
import DisplayTextComponent from "./DisplayTextComponent";
import {BaseInput} from "./BaseInput";

interface NumberComponentProps extends CommonProps {
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
}

const NumberComponent = ({
                             value,
                             onChange,
                             errorText,
                             onFocus,
                             status = StatusUpdateAnswer.NONE,
                             displayText,
                             editable,
                             required,
                             id,
                             hint
                         }: NumberComponentProps) => {
    const hasError = !!errorText;

    return (
            <FormControl disabled={!editable} required={required}>
                <FormLabel error={hasError} required={false}>
                    <DisplayTextComponent text={displayText} required={required} hint={hint}/>
                </FormLabel>
                <BaseInput
                        id={id}
                        value={value}
                        onChange={onChange}
                        onFocus={onFocus}
                        editable={editable}
                        required={required}
                        hasError={hasError}
                        type="number"
                        status={status}
                />
                {hasError ? <FormHelperText error>{errorText}</FormHelperText> : null}
            </FormControl>
    )
}

export default withSharedMemo(NumberComponent);